var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { phoneNumberToFormattedString, phoneNumberToE164, createProxyWithOverrides } from '@navinc/utils';
import { forwardRef } from 'react';
import { BasePatternInput } from '../base-pattern-input/base-pattern-input.js';
export const toPhoneNumber = (value) => phoneNumberToE164(value);
export const phoneNumberValidator = (phoneNumber, errorMessage = 'We need your full 10-digit phone number') => phoneNumber && phoneNumberToFormattedString(phoneNumber).length < 12 /* 12 due to `+1` in E164 format */
    ? errorMessage
    : undefined;
export const BasePhoneNumberInput = forwardRef((_a, ref) => {
    var { value, onChange } = _a, props = __rest(_a, ["value", "onChange"]);
    return (_jsx(BasePatternInput, Object.assign({ ref: ref, inputMode: "numeric", pattern: "999-999-9999", value: value !== undefined ? phoneNumberToFormattedString(value) : undefined, onChange: (e) => {
            e.target = createProxyWithOverrides(e.target, { value: phoneNumberToE164(e.target.value) });
            onChange === null || onChange === void 0 ? void 0 : onChange(e);
        } }, props)));
});
//# sourceMappingURL=base-phone-number-input.js.map